// client/src/components/admin/project/ProjectCompletionRefundModal.js
import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export default function ProjectCompletionRefundModal({ open, onClose, projectId, projectNumber, refundCalculation, onComplete }) {
  const [processing, setProcessing] = useState(false);

  if (!open || !refundCalculation) return null;

  const { totalDeposit, breakdown, totalUsed, refundAmount } = refundCalculation;

  const formatAmount = (amount) => {
    return amount?.toLocaleString() || '0';
  };

  const handleComplete = async () => {
    if (processing) return;
    
    if (!window.confirm('프로젝트를 완료 처리하시겠습니까?\n\n완료 처리 후에는 취소할 수 없습니다.')) {
      return;
    }

    setProcessing(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/projects/${projectId}/complete`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await res.json();

      if (data.ok) {
        alert('프로젝트가 완료 처리되었습니다.');
        if (onComplete) onComplete();
        onClose();
      } else {
        alert(data.message || '완료 처리에 실패했습니다.');
      }
    } catch (error) {
      console.error('완료 처리 오류:', error);
      alert('완료 처리 중 오류가 발생했습니다.');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="project-completion-refund-modal">
      <div className="project-completion-refund-modal__content" onClick={(e) => e.stopPropagation()}>
        {/* 헤더 */}
        <div className="project-completion-refund-modal__header">
          <div>
            <h2 className="project-completion-refund-modal__title">
              ✅ 프로젝트 완료 처리
            </h2>
            <div className="project-completion-refund-modal__subtitle">
              프로젝트: {projectNumber}
            </div>
          </div>
          <button onClick={onClose} className="project-completion-refund-modal__close">✕</button>
        </div>

        {/* 내용 */}
        <div className="project-completion-refund-modal__body">
          {/* 제목 */}
          <div className="project-completion-refund-modal__section-title">
            📊 결제 및 환불 내역
          </div>

          {/* 결제 포인트 */}
          <div className="project-completion-refund-modal__total-deposit">
            <div className="project-completion-refund-modal__total-label">💳 결제 포인트</div>
            <div className="project-completion-refund-modal__total-value">{formatAmount(totalDeposit)}P</div>
          </div>

          {/* 사용 내역 */}
          <div className="project-completion-refund-modal__usage-section">
            <div className="project-completion-refund-modal__usage-title">📍 사용 내역</div>
            
            {/* 기본 운영비 */}
            <div className="project-completion-refund-modal__usage-item">
              <div className="project-completion-refund-modal__usage-label">
                <div>• 기본 운영비</div>
                <div className="project-completion-refund-modal__usage-subtext">
                  └ 계획: {formatAmount(breakdown.plannedBaseOp)}P
                </div>
              </div>
              <span className="project-completion-refund-modal__usage-value">{formatAmount(breakdown.actualBaseOp)}P</span>
            </div>

            {/* 기본 리워드 */}
            <div className="project-completion-refund-modal__usage-item">
              <div className="project-completion-refund-modal__usage-label">
                <div>• 기본 리워드</div>
                <div className="project-completion-refund-modal__usage-subtext">
                  └ 계획: {formatAmount(breakdown.plannedReward)}P
                </div>
              </div>
              <span className="project-completion-refund-modal__usage-value">{formatAmount(breakdown.actualReward)}P</span>
            </div>

            {/* 구매당 리워드 */}
            {breakdown.plannedCPS > 0 && (
              <div className="project-completion-refund-modal__usage-item">
                <div className="project-completion-refund-modal__usage-label">
                  <div>• 구매당 리워드</div>
                  <div className="project-completion-refund-modal__usage-subtext">
                    └ 계획: {formatAmount(breakdown.plannedCPS)}P
                  </div>
                </div>
                <span className="project-completion-refund-modal__usage-value">{formatAmount(breakdown.actualCPS)}P</span>
              </div>
            )}

            {/* 구분선 */}
            <div className="project-completion-refund-modal__divider" />

            {/* 총 사용 */}
            <div className="project-completion-refund-modal__total-used-row">
              <span className="project-completion-refund-modal__total-used-label">📌 총 사용</span>
              <span className="project-completion-refund-modal__total-used-value">{formatAmount(totalUsed)}P</span>
            </div>
          </div>

          {/* 환불 예정 */}
          <div className="project-completion-refund-modal__refund-section">
            <div className="project-completion-refund-modal__refund-label">💰 환불 예정</div>
            <div className="project-completion-refund-modal__refund-value">{formatAmount(refundAmount)}P</div>
          </div>

          {refundAmount === 0 && (
            <div className="project-completion-refund-modal__no-refund">
              환불할 금액이 없습니다.
            </div>
          )}
        </div>

        {/* 푸터 */}
        <div className="project-completion-refund-modal__footer">
          <button onClick={onClose} className="project-completion-refund-modal__cancel-btn" disabled={processing}>
            취소
          </button>
          <button onClick={handleComplete} className="project-completion-refund-modal__complete-btn" disabled={processing}>
            {processing ? '처리 중...' : '완료 처리'}
          </button>
        </div>
      </div>
    </div>
  );
}

